import {minLength } from '../../../utils/form-validations';

export const addFormSchema = {};

export const maintenanceSchema = {
  type: 'object',
  properties: {
    maintenance_name: {
      type: 'string',
      minLength,
      errorMessage: {
        minLength: 'Must not have fewer than 3 characters',
      },
    },
    machines: {
      type: 'array',
      minItems: 1,
      errorMessage: {
        minItems: 'Please select atleast 1 Machine',
      },
    },
  },
  required: ['maintenance_name', 'machines'],
  additionalProperties: true,
};

// recurs_on
export const dailySchema = {
  type: 'object',
  properties: {
    daily_value: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Please select Recurs',
    },
  },
  required: ['daily_value'],
  additionalProperties: true,
};

// export const customDaysSchema = { type: 'number', minimum: 1, maximum: 30 };
export const customDaysSchema = {
  type: 'number',
  minimum: 1,
  errorMessage: 'Please enter Every Day(s)',
};

export const weeklySchema = {
  type: 'object',
  properties: {
    recurs_every: {
      type: 'number',
      minimum: 1,
      errorMessage: 'Please enter Recurs',
    },
    recurs_days: {
      type: 'array',
      minItems: 1,
      errorMessage: 'Please select Recurs',
    },
  },
  required: ['recurs_every', 'recurs_days'],
  additionalProperties: true,
};

export const monthlySchema = {
  type: 'object',
  properties: {
    monthly_value: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Please select Recurs',
    },
  },
  required: ['monthly_value'],
  additionalProperties: true,
};

export const monthlySchemaCustomDays = {
  type: 'object',
  properties: {
    day_of_month: {
      type: 'number',
      minimum: 1,
      errorMessage: 'Please enter Day',
    },
    recurs_every: {
      type: 'number',
      minimum: 1,
      errorMessage: 'Please enter Every Month(s)',
    },
  },
  required: ['day_of_month', 'recurs_every'],
  additionalProperties: true,
};

export const monthlySchemaEveryMonth = {
  type: 'object',
  properties: {
    nth_week: {
      type: 'number',
      minimum: 1,
      errorMessage: 'Please enter Nth Week',
    },
    recurs_days: {
      type: 'string',
      minLength,
      errorMessage: 'Please enter Recurs Day',
    },
    recurs_every: {
      type: 'number',
      minimum: 1,
      errorMessage: 'Please enter Recurs Every',
    },
  },
  required: ['nth_week', 'recurs_days', 'recurs_every'],
  additionalProperties: true,
};

export const yearlySchema = {
  type: 'object',
  properties: {
    recurs_every: {
      type: 'number',
      minimum: 1,
      errorMessage: 'Please enter Every Month(s)',
    },
    yearly_value: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Please select Recurs',
    },
  },
  required: ['recurs_every', 'yearly_value'],
  additionalProperties: true,
};

export const yearlySchemaCustomMonth = {
  type: 'object',
  properties: {
    month: {
      type: 'number',
      minimum: 1,
      errorMessage: 'Please enter Month',
    },
    day_of_month: {
      type: 'number',
      minimum: 1,
      errorMessage: 'Please enter Day of Month',
    },
  },
  required: ['month', 'day_of_month'],
  additionalProperties: true,
};

export const yearlySchemaCustomSelected = {
  type: 'object',
  properties: {
    nth_week: {
      type: 'number',
      minimum: 1,
      errorMessage: 'Please enter Nth Week',
    },
    recurs_days: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Please enter Recurs Days',
    },
    month: {
      type: 'number',
      minimum: 1,
      errorMessage: 'Please enter Month',
    },
  },
  required: ['nth_week', 'recurs_days', 'month'],
  additionalProperties: true,
};

export const severitySchema = { type: 'number', minimum: 1 };

export const assignTaskSchema = {
  type: 'object',
  properties: {
    assigned_to: {
      // type: 'array',
      type: 'string',
      minLength: 1,
      errorMessage: 'Please select Engineer',
    },
    // mt_remarks: {
    //   type: 'string',
    //   minLength,
    //   errorMessage: 'Must not have fewer than 3 characters',
    // },
    start_date: {
      type: 'string',
      minLength,
      errorMessage: {
        minLength: 'Must not have fewer than 3 characters',
      },
    },
    mt_time: {
      type: 'string',
      minLength,
      errorMessage: {
        minLength: 'Must not have fewer than 3 characters',
      },
    },
    schedule_type: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Please select Schedule Type',
    },
  },
  required: ['assigned_to', 'start_date', 'mt_time', 'schedule_type'],
  additionalProperties: true,
};